export enum AlertNotificationSeverity {
  info = "INFO",
  warning = "WARNING",
  important = "IMPORTANT",
  importantDetailed = "IMPORTANT_DETAILED",
}
